import Vue from "vue";
import moment from "moment";
import axios from "axios";
import config from "@/config/constants";
import Loader from "@/components/Loader.vue";
import WaitingRoom from "@/components/Session/WaitingRoom.vue";
import VideoRoomContainer from "@/components/Session/VideoRoomContainer.vue";
export default Vue.extend({
    name: "MeetingRoom",
    components: {
        Loader,
        WaitingRoom,
        VideoRoomContainer,
    },
    props: {
        type: { type: String, required: true },
        booking: { required: false, default: null },
    },
    data() {
        return {
            loading: true,
            isEarly: true,
            fetchedBooking: null,
            fetchedCoach: null,
            coach: null,
        };
    },
    mounted() {
        if (this.type === "dmh") {
            const now = moment();
            const start = moment(this.booking.startTime);
            this.isEarly = start.diff(now, "minutes") > 1;
            setTimeout(() => {
                this.loading = false;
            }, 300);
        }
        else if (this.type === "tmh") {
            this.getBooking();
        }
    },
    computed: {
        resolvedBooking() {
            return this.type === "tmh" ? this.fetchedBooking : this.booking;
        },
        resolvedCoach() {
            return this.type === "tmh" ? this.fetchedCoach : false;
        },
    },
    methods: {
        async getBooking() {
            try {
                const response = await axios.post(config.api_env + "/application/api/u/coaching/get-booking", {
                    user_id: this.$store.getters.user_id,
                    booking_id: this.$route.params.id,
                }, config.options);
                if (response.data.success) {
                    const fetchedBooking = response.data.booking;
                    if (!fetchedBooking._startDublinMs && fetchedBooking.start) {
                        fetchedBooking._startDublinMs = moment(fetchedBooking.start).valueOf();
                    }
                    this.fetchedBooking = fetchedBooking;
                    this.fetchedCoach = response.data.coach;
                    const now = moment();
                    const start = moment(fetchedBooking.start);
                    this.isEarly = start.diff(now, "minutes") > 1;
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.loading = false;
            }
        },
        x() {
            this.isEarly = false;
        },
    },
});
